var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcSubscriptionsHeader(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "35px",
    height: "29px",
    viewBox: "0 0 35 29",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icSubscriptionsHeader") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Upgrade-Users-Notifications",
    transform: "translate(-1418.000000, -196.000000)",
    fill: "#C1C1C1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-19",
    transform: "translate(1079.000000, 64.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Top",
    transform: "translate(16.000000, 27.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Upgrade",
    transform: "translate(230.000000, 90.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-17",
    transform: "translate(76.000000, 9.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.2320544,11.5133925 C47.735959,11.5133925 46.4649549,12.7216902 46.4649549,14.3076878 C46.4649549,14.835784 46.6147337,15.288682 46.8389787,15.6663818 L39.7342182,22.9922209 C37.790479,19.8202257 36.5194749,15.1382856 35.8458935,12.0414886 C36.8926525,11.5133925 37.6407002,10.4563456 37.6407002,9.17199517 C37.6407002,7.43560126 36.2199173,6 34.4995769,6 C32.7800827,6 31.3584536,7.43560126 31.3584536,9.17199517 C31.3584536,10.4563456 32.1065013,11.5133925 33.1532603,12.0414886 C32.4805251,15.1382856 31.2086748,19.8202257 29.2640894,22.9922209 L22.160175,15.6663818 C22.3844201,15.288682 22.5341989,14.835784 22.5341989,14.3076878 C22.5341989,12.7968884 21.3376611,11.5133925 19.7670994,11.5133925 C18.1965378,11.5133925 17,12.7216902 17,14.3076878 C17,15.8176327 18.1965378,17.1019831 19.7670994,17.1019831 L24.851962,34.4710493 C24.9272745,34.773551 25.226832,35 25.6000097,35 L43.4736104,35 C43.773168,35 44.0718793,34.773551 44.2216581,34.4710493 L49.2320544,17.0259304 C50.7281497,17.0259304 52,15.8176327 52,14.2316351 C51.9246875,12.7216902 50.7281497,11.5133925 49.2320544,11.5133925",
    id: "icSubscriptionsHeader"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSubscriptionsHeader);
export default __webpack_public_path__ + "static/media/icSubscriptionsHeader.fbce09c7aa0f680a7c6898f502b143b1.svg";
export { ForwardRef as ReactComponent };